import { SendFormData } from "../../wcl-helpers";

document.addEventListener('DOMContentLoaded', () => {

   if (document.querySelector('.wcl-likes-buttons')) {
      const likesButton = document.querySelectorAll('.wcl-js-likes-button');

      const quoteWrapper = document.querySelector('.wcl-quote');
      const quoteText = quoteWrapper.querySelector('.quote-text').textContent;
      const quoteAuthor = quoteWrapper.querySelector('.quote-author').textContent;

      const quoteRating = document.querySelector('.wcl-likes-buttons .wcl-likes-count span');

      likesButton.forEach(btn => {
         btn.addEventListener('click', e => {
            e.preventDefault();

            // Get data element
            const action = btn.getAttribute('data-type');

            // Add 'active' class immediately for buttons
            btn.classList.add('active');

            // Add 'disabled' class to all buttons
            likesButton.forEach(button => button.classList.add('disabled'));

            // Remove the 'active' class from all buttons except the one clicked
            likesButton.forEach(button => {
               if (button !== btn) {
                  button.classList.remove('active');
               }
            });

            let formData = new FormData();

            // Add wpnonce to data array
            formData.append('quote', quoteText);
            formData.append('author', quoteAuthor);
            formData.append('like_action', action);

            SendFormData('quote_likes', formData).then(function (res) {

               likesButton.forEach(button => button.classList.remove('disabled'));

               let response = JSON.parse(res);

               if (response.success == '1') {
                  quoteRating.textContent = response.current_rating;
               } else {
                  throw response.message;
               }

            }).catch(function (err) {
               // Error
               likesButton.forEach(button => button.classList.remove('disabled'));
            });
         });
      });
   }
});